export enum ExportType {
  CSV_DOWNLOAD = 0,
  EMAIL_ATTACHMENT = 1,
}
